import { SHOT_TYPE } from './selected-shots-viewer'

import { SHOT_TYPES } from '@/pages/home/explorer/helpers'

/**
 * Get stats from insights to perform shot quality calculation.
 * @param rallies Rallies data from insights.rallies
 * @param SHOT_TYPE shotNumberSelection 0 (serve), 1 (return), 2 (3rd shot),
 *                                      3 (4th shot), 4 (5th shot) or 999 (all)
 */
export function getStatsForQualityCalculation (rallies, shotNumberSelection) {
  if (!rallies) {
    // This is the player id
    return { 0: {}, 1: {}, 2: {}, 3: {} }
  }

  const stats = Array.from({ length: 4 }, () => ({}))
  for (let r = 0; r < rallies.length; r++) {
    const rally = rallies[r]
    if (Array.isArray(rally.shots)) {
      // let shotNumber = 0
      for (let shotNumber = 0; shotNumber < rally.shots.length; shotNumber++) {
        const shot = rally.shots[shotNumber]
        if (shot?.resulting_ball_movement) {
          if (shotNumber === shotNumberSelection || shotNumberSelection === SHOT_TYPE.ALL_SHOT) {
            if (!stats[shot.player_id][shot.shot_type]) {
              stats[shot.player_id][shot.shot_type] = []
            }

            // Initialize speedup if a shot is speedup
            if (shot.is_speedup && !stats[shot.player_id][SHOT_TYPES.SPEEDUP]) {
              stats[shot.player_id][SHOT_TYPES.SPEEDUP] = []
            }

            if (shot.resulting_ball_movement.trajectory) {
              stats[shot.player_id][shot.shot_type].push({
                ...shot.resulting_ball_movement.trajectory,
                // Used for quality calculation
                ...(shot.quality && Object.prototype.hasOwnProperty.call(shot.quality, 'overall')
                  ? { quality: shot.quality.overall }
                  : {})
              })

              // If shot is considered a speed up, push it also to the speedup array.
              // We have to do it twice here because some shot have a shot type but
              // is also considered a speed up
              if (shot.is_speedup) {
                stats[shot.player_id][SHOT_TYPES.SPEEDUP].push({
                  ...shot.resulting_ball_movement.trajectory,
                  // Used for quality calculation
                  ...(shot.quality && Object.prototype.hasOwnProperty.call(shot.quality, 'overall')
                    ? { quality: shot.quality.overall }
                    : {})
                })
              }
            }

            // Each rally has only 1 shotNumberSelection [Serve/Return/3rd ..etc] shot, break and iterate to the next rally
            if (shotNumber === shotNumberSelection) {
              break
            }
          }
        }
      }
    }
  }
  return stats
}

/**
 * Calculate shot quality of a given player's stats
 * @param {*} stats
 * @param {*} selected
 * @returns
 */
export function calculateQuality (stats, selected) {
  let total = 0
  const collected = selected.reduce((acc, cur) => {
    let now = acc
    if (stats[cur]) {
      stats[cur].forEach((bt) => {
        if (Object.prototype.hasOwnProperty.call(bt, 'quality')) {
          total += 1
          now += bt.quality
        }
      })
    }
    return now
  }, 0)

  return collected ? (collected / total).toFixed(1) * 100 : 0
}
